import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d594991e")

_pushScopeId("data-v-d594991e")
const _hoisted_1 = { class: "photo_swiper-container" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "swiper-zoom-container" }
const _hoisted_4 = {
  id: "",
  class: "ui__swiper_bottomMsg"
}
const _hoisted_5 = { class: "ui__swiper_leftBottom" }
const _hoisted_6 = { class: "ui__swiper_rightBottom" }
const _hoisted_7 = {
  id: "",
  class: "ui__swiper_bottomMsg"
}
const _hoisted_8 = { class: "ui__swiper_leftBottom" }
const _hoisted_9 = {
  key: 0,
  class: "toc_ui_photoDefect"
}
const _hoisted_10 = { class: "noImg" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "暂无图片", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "defectExplain" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_photoDefect = _resolveComponent("photoDefect")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "ui__swiper_main",
      id: "photoViewr",
      style: {height:_ctx.state.contentHeight + 'px'}
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgList, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "swiper-slide",
              key: item.photoIdStr
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("img", {
                  src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
                }, null, 8, ["src"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.state.photoName), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", null, _toDisplayString(_ctx.state.currentIndex+1) + "/" + _toDisplayString(_ctx.state.groupNum), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("span", null, _toDisplayString(_ctx.state.photoNameForeign), 1)
        ])
      ]),
      (!_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _withDirectives(_createVNode(_component_photoDefect, {
              dataList: _ctx.state.defectList
            }, null, 8, ["dataList"]), [
              [_vShow, _ctx.state.defectList.length>0]
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _withDirectives(_createVNode("div", _hoisted_10, [
      _hoisted_11,
      (_ctx.state.noImgCurrentDefectTxt)
        ? (_openBlock(), _createBlock("b", _hoisted_12, _toDisplayString(_ctx.state.noImgCurrentDefectTxt), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_13, [
        _withDirectives(_createVNode(_component_photoDefect, {
          dataList: _ctx.state.noImgExplain
        }, null, 8, ["dataList"]), [
          [_vShow, _ctx.state.noImgExplain.length>0]
        ])
      ])
    ], 512), [
      [_vShow, _ctx.noImg]
    ])
  ]))
})